export const NOT_INITIALIZED = 'NOT_INITIALIZED';
export const OK = 'OK';
